import React from 'react';
import { render } from 'react-dom';
import { renderToStaticMarkup } from 'react-dom/server';
import { createStore, compose } from 'redux';
import { connect } from 'react-redux';
import { install } from 'redux-loop';
import TextAppForm from './component';
import { reducer, Actions } from './reducer';

const createReduxStore = () => {
  return createStore(
    reducer,
    undefined,
    compose(
      install(),
      (typeof window !== 'undefined' && window.devToolsExtension) ? window.devToolsExtension() : (x) => x
    )
  );
};

const createContainer = () => {
  const connector = (s) => ({ model: s.toJS() });
  return connect(connector)(TextAppForm);
};

const standalone = (element) => {
  const store = createReduxStore();
  const Container = createContainer();

  render(
    <Container store={store} />,
    element
  );
};

const renderStaticMarkup = () => {
  const store = createReduxStore();
  const Container = createContainer();
  return renderToStaticMarkup(<Container store={store} staticRender />);
};

export default {
  reducer,
  Actions,
  View: TextAppForm,
  standalone,
  renderStaticMarkup,
};



/** WEBPACK FOOTER **
 ** ./shared-components/TextAppForm/index.js
 **/